export namespace QueryParams {
  export const CurrentPage = 'page'
  export const OrderProp = 'orderProp'
  export const OrderDirection = 'orderDirection'
  export const Type = 'filter'
}